import type { CollageDocument } from './document';
import { validateDocument } from './schemas';

export type NewDocumentOptions = {
  id?: string;
  name?: string;
  width?: number;
  height?: number;
  ppi?: number;
  background?: string | null;
  now?: string;
};

export function createDocument(options: NewDocumentOptions = {}): CollageDocument {
  const timestamp = options.now ?? new Date().toISOString();
  const id = options.id ?? globalThis.crypto.randomUUID();
  return validateDocument({
    schemaVersion: 1,
    id,
    name: options.name ?? 'Untitled',
    createdAt: timestamp,
    updatedAt: timestamp,
    canvas: {
      width: options.width ?? 2000,
      height: options.height ?? 2000,
      ppi: options.ppi ?? 300,
      blackAndWhite: false,
      background: options.background === undefined ? '#FFFFFF' : options.background,
      backgroundAssetId: null,
      backgroundImageOpacity: 1,
      backgroundImageBlur: 0,
      backgroundImageBrightness: 1,
      backgroundImageSaturation: 1,
      backgroundImageOffsetX: 0,
      backgroundImageOffsetY: 0,
    },
    assets: {},
    fonts: {},
    elements: [],
    layout: null,
  });
}
